module.exports = __webpack_public_path__ + "static/graph-2-3ed40eb08df16835946ad58a7dd73af8.svg";